import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface LinkProps extends RouterLinkProps {
  className?: string;
  children: React.ReactNode;
  external?: boolean;
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className = '', external = false, children, ...props }, ref) => {
    const baseStyles = 'text-rm-accent-500 hover:text-rm-accent-600 underline underline-offset-4 transition-colors';
    
    const classes = [baseStyles, className].filter(Boolean).join(' ');

    if (external || (typeof props.to === 'string' && props.to.startsWith('http'))) {
      return (
        <a
          ref={ref}
          href={props.to as string}
          className={classes}
          target="_blank"
          rel="noopener noreferrer"
          {...(props as any)}
        >
          {children}
        </a>
      );
    }

    return (
      <RouterLink ref={ref as any} className={classes} {...props}>
        {children}
      </RouterLink>
    );
  }
);

Link.displayName = 'Link';

export { Link };
export type { LinkProps };